import styled from "styled-components";

export const Container = styled.div`
  margin-bottom: 15px;
  .title {
    margin-bottom: 20px;
  }
`;
